import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, formatApiError } from "@/lib/api";
import { AlertTriangle, Loader2, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function TrialBanner() {
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const { data } = useQuery({ queryKey: ["business"], queryFn: () => api.get("/business").then((r) => r.data) });
  if (!data) return null;
  if (data.subscription_state !== "suspended") return null;

  const canSelfReactivate = data.suspended_reason === "inactivity_30d";

  const reactivate = async () => {
    setBusy(true);
    try {
      await api.post("/business/reactivate");
      await qc.invalidateQueries();
      toast.success("Hesabınız yeniden aktifleştirildi");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-xl border p-4 mb-6 flex flex-col sm:flex-row sm:items-center gap-3 border-red-200 bg-red-50" data-testid="trial-banner">
      <AlertTriangle className="w-5 h-5 text-red-600 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm">Hesabınız askıya alındı</p>
        <p className="text-xs text-muted-foreground mt-0.5">
          {canSelfReactivate
            ? "30 gün boyunca giriş yapılmadığı için askıya alındı. Tek tıkla yeniden aktifleştirebilirsiniz."
            : "Lütfen bizimle iletişime geçin."}
        </p>
      </div>
      {canSelfReactivate && (
        <Button size="sm" className="rounded-full bg-red-600 hover:bg-red-700 text-white shrink-0" disabled={busy} onClick={reactivate} data-testid="reactivate-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><RefreshCw className="w-4 h-4 mr-1.5" /> Yeniden Aktifleştir</>}
        </Button>
      )}
    </div>
  );
}
